
require('./personeticsView.scss');

// @ vendors
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');

// @ actions
const personeticsActions = require('actions/personeticsInboxInsights');
const personeticsCardMovementDeepLink = require('actions/personeticsDeepLinks');
const personeticsAccountMovementDeepLink = require('actions/personeticsDeepLinks');
const personeticsEmitedTransferMovementDeepLink = require('actions/personeticsDeepLinks');
const personeticsDetailsActions = require('actions/personeticsInsightDetails');
const personeticsSubscriptionActions = require('actions/personeticsSubscription');

// @ core
const { formatText } = require('core/i18n').i18n;
const modalHeaderImgUrl = require('assets/images/referrals-preview-logo.png');

// @ commons
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { EmptyState } = require('commonsComponents/emptyState');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKButton } = require('commonsComponents/OKButton');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const OKModal = require('components/commons/OKModal/OKModal');

// @ components
const { CallMeBack } = require('components/callMeBack/callMeBack');
const { PersoneticsRichTeaser } = require('components/personetics/personeticsRichTeaser');
const OKRadioGroup = require('components/commons/OKRadioGroup/OKRadioGroup');
const OKRadioSwitch = require('components/commons/OKRadioSwitch/OKRadioSwitch');
const PersoneticsSubscriptionModal = require('components/personetics/personeticsSubscriptionModal/personeticsSubscriptionModal');
const PersoneticsSubscriptionErrorModal = require('components/personetics/personeticsSubscribtionErrorModal/personeticsSubscribtionErrorModal');

// @constants
const {
    SELECTED_RADIO_ALL_INSIGHTS,
    SELECTED_RADIO_UNREAD_INSIGHTS
} = require('constants/personetics');
const {
    PERSONETICS_EVENT_CATEGORY,
    PERSONETICS_INBOX_EVENT_CATEGORY
} = require('constants/tagging');
// @helpers
const { FormattedText } = require('core/i18n').i18n;
const {
    recordLinkV2,
} = require("utilities/tagging");
//@images
const emptyStateImg = require('assets/images/icono.svg');
const openTutorialImg = require('assets/images/icon-tutorial.svg');

class PersoneticsView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedRadio: SELECTED_RADIO_ALL_INSIGHTS,
            showModal: false
        }
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.closeTertiaryModal = this.closeTertiaryModal.bind(this);
        this.getPersoneticsInsights = this.getPersoneticsInsights.bind(this);
        this.handleRadioGroupChange = this.handleRadioGroupChange.bind(this);
        this.handleGoBackClick = this.handleGoBackClick.bind(this);
        this.handlePrimaryButtonClick = this.handlePrimaryButtonClick.bind(this);
        this.checkboxClick = this.checkboxClick.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.updatePersoneticsSubscriptionStatus = this.updatePersoneticsSubscriptionStatus.bind(this);
    }

    componentDidMount() {
        const { immPersoneticsSubscriptionDetails } = this.props;
        this.props.getPersoneticsSubscriptionStatus();
        const isSubscribed = immPersoneticsSubscriptionDetails.get('isSubscribed');
        isSubscribed && this.getPersoneticsInsights();
        !isSubscribed && this.props.openPersoneticsSubscriptionModal();
    }

    getPersoneticsInsights() {
        const { getPersoneticsInboxInsights } = this.props;
        getPersoneticsInboxInsights();
    }

    handleRadioGroupChange(value) {
        const analyticsData = {
            categoriaEvento: "personetics",
            accionEvento: `ir a ${value}`,
        }
        this.setState({
            selectedRadio: value
        });
        recordLinkV2(analyticsData)
        this.getPersoneticsInsights();
    }

    handleGoBackClick(gobackFlag) {
        const analyticsData = {
            categoriaEvento: PERSONETICS_EVENT_CATEGORY,
            accionEvento: "volver",
            zonaInicio: PERSONETICS_INBOX_EVENT_CATEGORY
        }
        gobackFlag !== true ? recordLinkV2(analyticsData) : null
        this.props.history.push('/myprofile/global');
    }

    buildRadioSwitches() {
        return (
            <div className="personetics-view__radio-switch" >
                <OKRadioGroup
                    name="personeticsOptions"
                    onChange={value => this.handleRadioGroupChange(value)}
                    selectedValue={this.state.selectedRadio}
                >
                    <OKRadioSwitch
                        className="personetics-view__radio-switch-item"
                        value={SELECTED_RADIO_UNREAD_INSIGHTS}
                    >
                        <FormattedText value="personeticsView-personeticsView_unreadInsights" />
                    </OKRadioSwitch>
                    <OKRadioSwitch
                        className="personetics-view__radio-switch-item"
                        value={SELECTED_RADIO_ALL_INSIGHTS}
                    >
                        <FormattedText value="personeticsView-personeticsView_allInsights" />
                    </OKRadioSwitch>
                </OKRadioGroup>
            </div>
        );
    }

    buildEmptyState() {
        return (
            <React.Fragment>
                <div className="personetics-view__empty-state--container col-xs-12">
                    <div className="personetics-view__empty-state-image col-xs-4">
                        <img src={emptyStateImg} />
                    </div>
                    <div className="personetics-view__empty-state-content col-xs-8">
                        <h3 className="personetics-view__empty-state-content-title">
                            <FormattedText value="personeticsView-personeticsView_emptyTeaserHeader" />
                        </h3>
                        <p className="personetics-view__empty-state-content-description">
                            <FormattedText value="personeticsView-personeticsView_emptyTeaserText" />
                        </p>
                    </div>
                </div>
                <div className="personetics-view__back-button">
                    <OKButton
                        modifier="primary"
                        onClick={this.handleGoBackClick}
                    >
                        <FormattedText value="personeticsView-personeticsView_backButtonText" />
                    </OKButton>
                </div>
            </React.Fragment>
        )
    }

    buildInboxInsightsContent() {
        const {
            getPersoneticsInsightDetails,
            immInboxInsights,
            immInsightDetails,
            setPersoneticsCardMovementRequest,
            setPersoneticsAccountMovementRequest,
            setPersoneticsEmitedTransferMovementRequest
        } = this.props;
        const clickedId = immInboxInsights.get('clickedId');
        const inboxInsights = immInboxInsights.get('inboxInsights');
        let teasers = '';
        switch (this.state.selectedRadio) {
            case SELECTED_RADIO_UNREAD_INSIGHTS:
                const unreadInsights = immInboxInsights.get('inboxInsights').filter((insight) => {
                    return insight.get('status') !== 'read'
                })
                if (unreadInsights.size === 0 || inboxInsights.size === 0) {
                    teasers = this.buildEmptyState()
                }
                else {
                    teasers = (
                        <React.Fragment>
                            <PersoneticsRichTeaser
                                clickedId={clickedId}
                                getPersoneticsInsightDetails={getPersoneticsInsightDetails}
                                immInboxInsights={unreadInsights}
                                assetsBaseUrl={immInboxInsights.get('imgURL')}
                                unread={true}
                                immInsightDetails={immInsightDetails}
                            />
                            <div className="personetics-view__footer-separator"></div>
                        </React.Fragment>
                    )
                }
                break;

            case SELECTED_RADIO_ALL_INSIGHTS:

                if (inboxInsights.size !== 0) {
                    teasers = (
                        <React.Fragment>
                            <PersoneticsRichTeaser
                                clickedId={clickedId}
                                getPersoneticsInsightDetails={getPersoneticsInsightDetails}
                                immInboxInsights={immInboxInsights}
                                immInsightDetails={immInsightDetails}
                                assetsBaseUrl={immInboxInsights.get('imgURL')}
                                setPersoneticsCardMovementRequest={setPersoneticsCardMovementRequest}
                                setPersoneticsAccountMovementRequest={setPersoneticsAccountMovementRequest}
                                setPersoneticsEmitedTransferMovementRequest={setPersoneticsEmitedTransferMovementRequest}
                            />
                            <div className="personetics-view__footer-separator"></div>
                        </React.Fragment>
                    );
                }
                else {
                    teasers = this.buildEmptyState()
                }
                break;
        }
        return (
            teasers
        );
    }

    closeModal() {
        const analyticsData = {
            categoriaEvento: PERSONETICS_EVENT_CATEGORY,
            accionEvento: "baja mis finanzas",
            etiquetaEvento: "close",
            zonaInicio: PERSONETICS_INBOX_EVENT_CATEGORY
        }
        recordLinkV2(analyticsData);
        this.props.closePersoneticsModal();
    }

    handlePrimaryButtonClick() {
        const { postPersoneticsUnsubscriptionStatus } = this.props;
        const analyticsData = {
            categoriaEvento: PERSONETICS_EVENT_CATEGORY,
            accionEvento: "baja mis finanzas",
            etiquetaEvento: "dar de baja",
            zonaInicio: PERSONETICS_INBOX_EVENT_CATEGORY
        }
        recordLinkV2(analyticsData);
        postPersoneticsUnsubscriptionStatus();
    }

    buildErrorContentModal(showPersoneticsSubscribeErrorModal) {
        return (
            <PersoneticsSubscriptionErrorModal
                title={formatText('personeticsSubscriptionErrorModal-title')}
                description={formatText('personeticsSubscriptionErrorModal-description')}
                handleSubmit={this.closeModal}
                showModal={showPersoneticsSubscribeErrorModal}
            />
        );
    }

    buildModal(showPersoneticsUnsubscribeModal) {
        const { immPersoneticsSubscriptionDetails } = this.props;

        return (
            <OKModal
                headerType="image"
                size="large"
                headerContent={modalHeaderImgUrl}
                headerImageWidth={'262px'}
                title={formatText('personeticsUnsubscriptionModal-modalTitle')}
                description={formatText('personeticsUnsubscriptionModal-modalSubtitle')}
                footerType="navigation"
                isOpen={showPersoneticsUnsubscribeModal}
                shouldCloseOnOverlayClick={false}
                onCloseCallback={this.closeModal}
                overlayClassName="personetics-unsubscription-modal"
                primaryButtonText={formatText('personeticsUnsubscriptionModal-modalButtonText')}
                primaryButtonLoading={immPersoneticsSubscriptionDetails.get('postUnsubscriptionStatusFetching')}
                tertiaryButtonText={formatText('personeticsUnsubscriptionModal-modalLinkText')}
                onPrimaryButtonClick={this.handlePrimaryButtonClick}
                onTertiaryButtonClick={this.closeTertiaryModal}
            />
        )
    }
    closeTertiaryModal() {
        const analyticsData = {
            categoriaEvento: PERSONETICS_EVENT_CATEGORY,
            accionEvento: "baja mis finanzas",
            etiquetaEvento: "mantener servicio",
            zonaInicio: PERSONETICS_INBOX_EVENT_CATEGORY
        }
        recordLinkV2(analyticsData);
        this.props.closePersoneticsModal();
    }

    openModal() {
        const analyticsDataLink = {
            categoriaEvento: PERSONETICS_EVENT_CATEGORY,
            accionEvento: "darse de baja",
            etiquetaEvento: "link",
            zonaInicio: PERSONETICS_INBOX_EVENT_CATEGORY
        }
        recordLinkV2(analyticsDataLink);

        const analyticsData = {
            categoriaEvento: PERSONETICS_EVENT_CATEGORY,
            accionEvento: "baja mis finanzas",
            etiquetaEvento: "open",
            zonaInicio: PERSONETICS_INBOX_EVENT_CATEGORY
        }
        recordLinkV2(analyticsData);
        this.props.openPersoneticsUnsubscriptionModal()
    }

    buildLinkText() {
        const normalText = formatText('personeticsUnsubscriptionModal-footerLinkPreText');
        const linkText = formatText('personeticsUnsubscriptionModal-footerLinkText');
        return (
            <div className="personetics-view__footer-link-wrapper">
                {normalText}
                <span className="personetics-view__footer-link" onClick={this.openModal}> {linkText}</span>
            </div>
        )
    }

    checkboxClick(value) {
        this.props.termsAndConditionscheckboxClick(value);
    }

    handleCloseModal() {
        this.props.closePersoneticsModal();
        this.props.history.push('/myprofile/global');
    }

    updatePersoneticsSubscriptionStatus() {
        this.props.postPersoneticsSubscriptionStatus();
    }

    subscribeModalContent(checkboxChecked, isPersoneticsAlreadySubscribed, showSubscriptionModal) {
        return (
            <PersoneticsSubscriptionModal
                checkboxChecked={checkboxChecked}
                checkboxClick={this.checkboxClick}
                handleClose={this.handleCloseModal}
                handleSubmit={this.updatePersoneticsSubscriptionStatus}
                isUpdatingPersoneticsSubscription={isPersoneticsAlreadySubscribed}
                showModal={showSubscriptionModal}
            />
        );
    }

    render() {
        const { immInboxInsights, immPersoneticsSubscriptionDetails } = this.props;
        const title = (<FormattedText value="personeticsView-personeticsView_headerTitle" />)
        const isSubscribed = immPersoneticsSubscriptionDetails.get('isSubscribed');
        const insightsContent = this.buildInboxInsightsContent();
        const radioSwitchContent = this.buildRadioSwitches();
        const mappingBreadcrumb = [
            {
                text: <FormattedText value="breadcrumb-global" />,
                url: '/myprofile/global'
            },
            {
                text: <FormattedText value="personeticsView-personeticsView_news" />,
                url: ''
            }
        ];
        const tutorialTooltipTarget = (
            <img
                src={openTutorialImg}
                className="personetics-teaser__tooltip-element"
            />
        );
        const tutorial = (
            <OKTooltip
                content="personetics-personetics_teaserTooltip"
                offset={[0, -15]}
                target={tutorialTooltipTarget}
            />
        );
        const OKHeaderView = (
            <OKCover
                size="medium"
                section="accounts"
                customClass="col-xs-12"
            >
                <OKHeaderSubPage
                    breadcrumbConfig={mappingBreadcrumb}
                    finalTitle={title}
                    tutorial={tutorial}
                />
            </OKCover>
        );
        let content;

        if (immInboxInsights.get('isFetching')) {
            content = <LoadingSection />;
        }
        else if (immInboxInsights.get('error')) {
            content = (
                <div className="personetics-view__empty-state">
                    <EmptyState
                        primaryText={formatText('personeticsView-personeticsView_errorStatePrimaryText')}
                        iconType="nointernet-banking"
                    />
                </div>
            );
        }
        else {
            content = (
                <div>
                    {radioSwitchContent}
                    {insightsContent}
                </div>
            )
        }

        let showPersoneticsUnsubscribeModal = false;
        const showPersoneticsSubscribeErrorModal = immPersoneticsSubscriptionDetails.get('showErrorModal');
        const showSubscriptionModal = !isSubscribed && immPersoneticsSubscriptionDetails.get('showSubscriptionModal');

        if (!showPersoneticsSubscribeErrorModal && (immPersoneticsSubscriptionDetails.get('postUnsubscriptionStatusFetching')
            || immPersoneticsSubscriptionDetails.get('showUnsubscriptionModal'))) {
            showPersoneticsUnsubscribeModal = true;
        }

        if (immPersoneticsSubscriptionDetails.get('postUnsubscriptionStatusSuccess')) {
            this.handleGoBackClick(true);
        }

        const checkboxChecked = immPersoneticsSubscriptionDetails.get('termsAndConditionChecked');

        return (
            <div className="personetics-view">
                <div className="container-fluid">
                    <div className="row">
                        {OKHeaderView}
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="row grid-view--content-position-negative">
                        <div className="col-xs-12 col-md-8">
                            <div className="row">
                                <OKSectionBox>
                                    {isSubscribed && content}
                                    {isSubscribed && !immInboxInsights.get('isFetching') && this.buildLinkText()}
                                    {this.subscribeModalContent(checkboxChecked, isSubscribed, showSubscriptionModal)}
                                    {this.buildModal(showPersoneticsUnsubscribeModal)}
                                    {this.buildErrorContentModal(showPersoneticsSubscribeErrorModal)}
                                </OKSectionBox>
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-4">
                            <div className="row">
                                <div className="col-xs-12 col-sm-6 col-md-12">
                                    <CallMeBack isSmall={true} pageTitle={formatText('landingHeader-teasers')} />
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation">
                                    <CommercialAds path="my-finances" type="banner-a" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

PersoneticsView.propTypes = {
    closePersoneticsModal: PropTypes.func.isRequired,
    getPersoneticsInboxInsights: PropTypes.object.isRequired,
    getPersoneticsInsightDetails: PropTypes.func.isRequired,
    getPersoneticsSubscriptionStatus: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immInboxInsights: PropTypes.object.isRequired,
    immInsightDetails: PropTypes.object.isRequired,
    immPersoneticsSubscriptionDetails: PropTypes.object.isRequired,
    openPersoneticsUnsubscriptionModal: PropTypes.func.isRequired,
    openPersoneticsSubscriptionModal: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    postPersoneticsUnsubscriptionStatus: PropTypes.func.isRequired,
    postPersoneticsSubscriptionStatus: PropTypes.func.isRequired,
    setPersoneticsCardMovementRequest: PropTypes.func.isRequired,
    setPersoneticsAccountMovementRequest: PropTypes.func.isRequired,
    setPersoneticsEmitedTransferMovementRequest: PropTypes.func.isRequired,
    termsAndConditionscheckboxClick: PropTypes.func.isRequired,
};
PersoneticsRichTeaser.defaultProps = {
    unread: false
}
module.exports.constructor = PersoneticsView;
module.exports.PersoneticsView = connect(
    state => ({
        immInboxInsights: state.personeticsInboxInsights,
        immInsightDetails: state.personeticsInsightDetails,
        immPersoneticsSubscriptionDetails: state.personeticsSubscription,
    }), {
    closePersoneticsModal: personeticsSubscriptionActions.closePersoneticsModal,
    getPersoneticsInboxInsights: personeticsActions.getPersoneticsInboxInsights,
    getPersoneticsSubscriptionStatus: personeticsSubscriptionActions.getPersoneticsSubscriptionStatus,
    openPersoneticsUnsubscriptionModal: personeticsSubscriptionActions.openPersoneticsUnsubscriptionModal,
    openPersoneticsSubscriptionModal: personeticsSubscriptionActions.openPersoneticsSubscriptionModal,
    postPersoneticsSubscriptionStatus: personeticsSubscriptionActions.postPersoneticsSubscriptionStatus,
    postPersoneticsUnsubscriptionStatus: personeticsSubscriptionActions.postPersoneticsUnsubscriptionStatus,
    getPersoneticsInsightDetails: personeticsDetailsActions.getPersoneticsInsightDetails,
    setPersoneticsAccountMovementRequest: personeticsAccountMovementDeepLink.setPersoneticsAccountMovementRequest,
    setPersoneticsCardMovementRequest: personeticsCardMovementDeepLink.setPersoneticsCardMovementRequest,
    setPersoneticsEmitedTransferMovementRequest: personeticsEmitedTransferMovementDeepLink.setPersoneticsEmitedTransferMovementRequest,
    termsAndConditionscheckboxClick: personeticsSubscriptionActions.termsAndConditionscheckboxClick,
}
)(withRouter(PersoneticsView));
